class TimezonesController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
    }
}

export const timezonesComponent: ng.IComponentOptions = {
    controller: TimezonesController,
    template: require('./timezones.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/settings/timezones/timezones.component.ts